import FilterChip from "shared/FilterChip";
import type { MeetingEmployeeOption } from "../api/MeetingsApi";
import { OVERDUE_DAYS, overdueTier } from "./meetingUtils";
import type { OverdueTier } from "./meetingUtils";

export type OverdueFilter = OverdueTier | "";

export function matchesOverdue(filter: OverdueFilter, lastMeetingDate: string | null): boolean {
  return !filter || overdueTier(lastMeetingDate) === filter;
}

/** Two toggle chips, one per tier, each with its employee count. Clicking the active one clears it. */
export default function OverdueChips({ employees, value, onChange }: {
  employees: MeetingEmployeeOption[];
  value: OverdueFilter;
  onChange: (v: OverdueFilter) => void;
}) {
  const never = employees.filter((e) => overdueTier(e.last_meeting_date) === "never").length;
  const stale = employees.filter((e) => overdueTier(e.last_meeting_date) === "stale").length;
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Meeting overdue filter">
      <FilterChip active={value === "never"} onClick={() => onChange(value === "never" ? "" : "never")} count={never}>
        Never met
      </FilterChip>
      <FilterChip active={value === "stale"} onClick={() => onChange(value === "stale" ? "" : "stale")} count={stale}>
        Over {OVERDUE_DAYS} days
      </FilterChip>
    </div>
  );
}
